import { withBemMod } from '@bem-react/core';
import { cnTextinput } from '../Textinput';
import './Textinput_view_default.css';
/**
 * Модификатор, отвечающий за внешний вид текстового поля.
 * @param {ITextinputViewDefaultProps} props
 */
export var withViewDefault = withBemMod(cnTextinput(), { view: 'default' });
